import React from "react";
import styles from "./md-icon.scss";
export default function Check24(props) {
    return (
        <div className={styles.view}>
            <svg width="24" height="24" viewBox="0 0 24 24" shapeRendering="crispEdges" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.55 18L3.85 12.3L5.275 10.875L9.55 15.15L18.725 5.97501L20.15 7.40001L9.55 18Z" fill={props.color || "#FFFFFF"} />
            </svg>
        </div>
    );
};